export const TEXT = {
  addInfo: 'split.web.add.info',
  addressHelper: 'split.web.address.helper',
  addressLabel: 'split.web.address.label',
  amount: 'split.web.amount',
  cityHelper: 'split.web.city.helper',
  cityLabel: 'split.web.city.label',
  comment: 'split.web.comment',
  nameLabel: 'split.web.name.label',
  noAmount: 'split.web.no.amount',
  send: 'split.web.send',
  validationRequired: 'split.web.validation.required',
  validationCardNotValid: 'split.web.validation.card.not.valid',
  commission: 'split.web.commission',
  notActive: 'split.web.not.active',
  closedDescription: 'split.web.closed.description',
  error: 'split.web.error',
  confirmTitle: 'split.web.confirm.title',
  confirmDescription: 'split.web.confirm.description',
  otp: 'split.web.otp',
  confirm: 'split.web.confirm',
  cancel: 'split.web.cancel',
  cardNumber: 'split.web.card.number',
  ready: 'split.web.ready',
  close: 'split.web.close',
  successOperation: 'split.web.success.operation',
  successDescriptionWithName: 'split.web.description.with.name',
  successDescription: 'split.web.success.description',
  transferDetails: 'split.web.transfer.details',
  transferDirection: 'split.web.transfer.direction',
  collectMoney: 'split.web.collect.money',
  recipient: 'split.web.recipient',
  continue: 'split.web.continue',
  totalAmount: 'split.web.total.amount',
  totalAmountEmpty: 'split.web.total.amount.empty',
  transferHelper: 'split.web.transfer.helper',
  expireDate: 'split.web.expire.date',
  cvv: 'split.web.cvv',
  failTransfer: 'split.web.fail.transfer',
  tryLater: 'split.web.try.later',
  tryAgain: 'split.web.try.again',
  expirePlaceholder: 'split.web.expire.placeholder',
  minAmount: 'split.web.min.amount',
  maxAmount: 'split.web.max.amount',
  findYourself: 'split.web.find.yourself',
  validationExpireDateNotValid: 'validation.expire.date.not.valid',
  validationCvvNotValid: 'validation.cvv.not.valid',
  errorChooseYourself: 'split.web.error.choose.yourself',
  senderNameLabel: 'split.web.sender.name.label',
  senseBannerTitle: 'split.web.sense.banner.title',
  senseBannerSubTitle: 'split.web.sense.banner.sub.title',
  senseBannerLink: 'split.web.sense.banner.link',
  payCard: 'split.web.pay.card',
  pay: 'split.web.pay',
  submit: 'split.web.submit',
  from: 'split.web.amount.from',
  to: 'split.web.amount.to',
  copyright: 'split.web.copyright',
  changeAmountHint: 'split.web.change.amount.hint',
  status: 'split.web.status',
  expiresIn: 'split.web.expires.in',
  statusActive: 'split.web.status.active',
};
